import { useTranslations } from 'next-intl';

export const EmptyMessageItem = () => {
	const t = useTranslations('General');

	return (
		<div className="empty">
			<div className="empty__img empty__img--message">
			</div>
			<div className="empty__title">{t('lbl_NoMsg_Note')}</div>
		</div>
	)
}